import { useLocalStorage } from 'react-use';

export const useDietaryRestrictionsWarningAck = () => {
  const [
    orderIdToDietaryRestrictionsWarningAck = {},
    setOrderIdToDietaryRestrictionsWarningAck,
  ] = useLocalStorage<Record<number, boolean>>(
    'dietary-restrictions-warning-acknowledged'
  );

  return {
    orderIdToDietaryRestrictionsWarningAck,
    setOrderIdToDietaryRestrictionsWarningAck,
  };
};
